<template>
    <ModalComponent
        :name="'anular-' + id"
        title="Anular entradas"
        v-on:close="() => close(false)"
    >
        <template>
            <div class="row">
                <div class="col-12">
                    <h3 class="font-weight-bold">Se anularan las siguientes entradas</h3>
                </div>
                <div class="col-12">
                    <div class="table-responsive">
                        <table class="table table-hover text-nowrap">
                            <thead>
                                <tr>
                                    <th>Descripción</th>
                                    <th>Precio + G.G</th>
                                    <th>Código qr</th>
                                    <th>Zona</th>
                                    <th>Fila/Asiento</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ entrada.concepto }}</td>
                                    <td>{{ entrada.precio | calcular_precio_entrada(entrada) }}</td>
                                    <td>{{ entrada.qr_code }}</td>
                                    <td>{{ entrada.asiento ? entrada.asiento.zona : '' }}</td>
                                    <td>
                                        <template v-if="entrada.asiento">
                                            {{ entrada.asiento.fila }}/{{ entrada.asiento.asiento }}
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <h1 class="font-weight-bold">¿ANULAR ENTRADA?</h1>
                </div>
                <div class="col-12 text-center">
                    <div v-if="entrada.taquilla == 1">
                        <template v-if="pedido.datafono_response">
                            <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularConDatafono(false)">ANULAR</Button>
                            <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularConDatafono(true)">ANULAR SIN GG</Button>
                            <DatafonoDevolucionComponent 
                                v-if="anular_con_datafono"
                                :importe="importe_datafono"
                                :pedido="pedido.datafono_response.pedido"
                                :rts="pedido.datafono_response.identificadorRTS"
                                :datafono_id="pedido.datafono_id"
                                @devolucionCorrecta="anuladaConDatafono"
                            />
                        </template>
                        <template v-else>
                            <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularEntradas(false)">ANULAR</Button>
                            <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularEntradas(true)">ANULAR SIN GG</Button>
                        </template>                        
                    </div>
                    <div v-else-if="evento_pasado == false">
                        <template v-if="metodo_pago == 1 || 3">
                            <template>
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularEntradas(false)">ANULAR</Button>
                            </template>
                        </template>
                        <ocultar-con-password message="Para anular una entrada con gastos de gestión tienes que poner una contraseña:" v-else>
                            <template>
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularEntradas(false)">ANULAR</Button>
                            </template>
                        </ocultar-con-password>
                        <template>
                            <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularEntradas(true)">ANULAR SIN GG</Button>
                        </template>
                    </div>
                    <div v-else-if="evento_pasado == true">
                        <ocultar-con-password message="Para anular una entrada tienes que poner una contraseña:">
                            <template>
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularEntradas(false)">ANULAR</Button>
                                <Button :disabled="disableButton" type="button" name="button" style="margin: 10px" @click="anularEntradas(true)">ANULAR SIN GG</Button>
                            </template>
                        </ocultar-con-password>
                    </div>
                    <div v-if="error" class="col-12 alert alert-danger">
                        {{ error }}
                    </div>
                </div>
            </div>
        </template>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import OcultarConPassword from "@/components/backend/components/OcultarConPassword.vue";
    import DatafonoDevolucionComponent from "@/components/backend/datafono/DatafonoDevolucionComponent";

    export default {
        props: ['entrada', 'metodo_pago', 'sesion_id', 'evento_pasado', 'evento_id', 'id', 'pedido'],
        data() {
            return {
                email: null,
                loading: false,
                checkedNames: [],
                disableButton: false,
                error: null,
                anular_con_datafono: false,
                importe_datafono: null,
                anular_sin_gastos: false,
                response_datafono: null
            }
        },
        methods: {
            close() {
                this.error = null;
                this.$emit('close', 'anular-' + this.id);
            },
            anularConDatafono(sin_gd) {
                this.anular_sin_gastos = sin_gd;
                this.importe_datafono = this.calcularImporte(sin_gd);
                this.anular_con_datafono = true;
            },
            anuladaConDatafono(response) {
                this.response_datafono = response;
                this.anularEntradas(this.sin_gd);
            },
            anularEntradas(sin_gd) {
                this.loading = true;
                const data = {
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    qr_code: this.entrada.qr_code,
                    sin_gd: sin_gd,
                };

                if(this.response_datafono) {
                    data.response_datafono = this.response_datafono;
                }

                this.disableButton = true;

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.entradas.anular'), data).then(res => {
                    this.$toast.success(res.data.message);
                    this.close();
                    this.$emit('anulada');
                }).catch(error => {
                    if (error.response.data.message) {
                        this.$toast.error(error.response.data.message);
                        this.error = error.response.data.message;
                    }
                }).finally(() => this.loading = false, this.disableButton = false);
            },
            calcularImporte(sin_gd) {
                let importe = 0;

                importe = importe + parseFloat(this.entrada.precio);

                if(!sin_gd && this.entrada.price_management && ! this.entrada.price_management_interno) {
                    importe = importe + parseFloat(this.entrada.price_management);
                }

                return importe;
            }
        },
        components: {
            ModalComponent, OcultarConPassword, DatafonoDevolucionComponent
        }
    }
</script>
